const COUNT_TYPES = {
  count: 'по шт',
  kg: 'по кг',
  litr: 'по литр',
}

export const COUNT_TYPE_OPTIONS = [
  { label: 'по шт', value: 'count' },
  { label: 'по кг', value: 'kg' },
  { label: 'по литр', value: 'litr' },
]

export function getCountTypeLabel(countType) {
  return COUNT_TYPES[countType] || countType || '—'
}

export function formatMoney(value, suffix = '₸') {
  const amount = Number(value)
  if (Number.isNaN(amount)) return `0 ${suffix}`
  return `${new Intl.NumberFormat('ru-RU').format(amount)} ${suffix}`
}

export function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString('ru-RU', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}
